module.exports = __webpack_public_path__ + "media/promo/courses/images/s2-dad9b2d352234659ae6a47f301d832a6.jpg";